module.exports = __webpack_public_path__ + "static/media/ruppee.0fd4e949.png";